
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playmakerEmbed",
      function () {
        return require("private-next-pages/playmakerEmbed/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playmakerEmbed"])
      });
    }
  